var exports = {
  "In": "TextualAttachmentPreview.module__textualPreview___YnhJR1",
  "KR": "TextualAttachmentPreview.module__previewSurface___YnhJR1",
  "cA": "TextualAttachmentPreview.module__previewActions___YnhJR1",
  "wL": "TextualAttachmentPreview.module__previewActionsVisible___YnhJR1",
  "VA": "TextualAttachmentPreview.module__previewActionButton___YnhJR1" + " " + __webpack_require__(377561)["AS"],
  "nJ": "TextualAttachmentPreview.module__copyIcon___YnhJR1",
  "fs": "TextualAttachmentPreview.module__inlinePreviewSurface___YnhJR1",
  "vd": "TextualAttachmentPreview.module__previewViewport___YnhJR1",
  "uL": "TextualAttachmentPreview.module__previewViewportCollapsed___YnhJR1",
  "q4": "TextualAttachmentPreview.module__previewViewportExpanded___YnhJR1",
  "Nv": "TextualAttachmentPreview.module__csvTableViewport___YnhJR1",
  "rV": "TextualAttachmentPreview.module__csvTableMarkup___YnhJR1",
  "uT": "TextualAttachmentPreview.module__previewCode___YnhJR1",
  "O9": "TextualAttachmentPreview.module__previewCodeWrap___YnhJR1",
  "VP": "TextualAttachmentPreview.module__previewError___YnhJR1",
  "Ml": "TextualAttachmentPreview.module__loadingState___YnhJR1",
  "qr": "TextualAttachmentPreview.module__footer___YnhJR1",
  "X1": "TextualAttachmentPreview.module__expandButton___YnhJR1" + " " + __webpack_require__(377561)["AS"],
  "eO": "TextualAttachmentPreview.module__expandIcon___YnhJR1",
  "t2": "TextualAttachmentPreview.module__expandIconExpanded___YnhJR1",
  "qt": "TextualAttachmentPreview.module__fileSection___YnhJR1",
  "gM": "TextualAttachmentPreview.module__fileMeta___YnhJR1",
  "Md": "TextualAttachmentPreview.module__fileName___YnhJR1",
  "Ov": "TextualAttachmentPreview.module__fileSize___YnhJR1",
  "zt": "TextualAttachmentPreview.module__footerActions___YnhJR1",
  "uH": "TextualAttachmentPreview.module__controlButton___YnhJR1" + " " + __webpack_require__(377561)["AS"],
  "RJ": "TextualAttachmentPreview.module__languagePositioner___YnhJR1",
  "tP": "TextualAttachmentPreview.module__languagePopup___YnhJR1",
  "Nl": "TextualAttachmentPreview.module__languageSearchWrap___YnhJR1",
  "nb": "TextualAttachmentPreview.module__languageSearchInput___YnhJR1",
  "qm": "TextualAttachmentPreview.module__languageEmpty___YnhJR1",
  "xl": "TextualAttachmentPreview.module__languageList___YnhJR1",
  "O6": "TextualAttachmentPreview.module__languageItem___YnhJR1",
  "d6": "TextualAttachmentPreview.module__languageItemHighlighted___YnhJR1",
  "J6": "TextualAttachmentPreview.module__languageItemSelected___YnhJR1",
  "xu": "TextualAttachmentPreview.module__languageItemIndicator___YnhJR1",
  "lh": "TextualAttachmentPreview.module__languageOptionContent___YnhJR1",
  "XO": "TextualAttachmentPreview.module__languageOptionCode___YnhJR1",
  "_s": "TextualAttachmentPreview.module__languageOptionCanonical___YnhJR1",
  "CR": "TextualAttachmentPreview.module__modalRoot___YnhJR1",
  "Ij": "TextualAttachmentPreview.module__modalLayout___YnhJR1",
  "S3": "TextualAttachmentPreview.module__modalBody___YnhJR1",
  "fn": "TextualAttachmentPreview.module__modalPreviewSurface___YnhJR1",
  "CM": "TextualAttachmentPreview.module__previewViewportFill___YnhJR1",
  "v6": "TextualAttachmentPreview.module__previewCodeFill___YnhJR1",
};

module.exports = exports;
